import { render, staticRenderFns } from "./SalesBeforeTax.vue?vue&type=template&id=a8e055dc&"
import script from "./SalesBeforeTax.vue?vue&type=script&lang=js&"
export * from "./SalesBeforeTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports